<div style="width: 95%;" [attr.dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'" >
    <div mat-dialog-title class="modal-header-bg d-flex justify-content-end px-3 pt-1"></div>
    <div mat-dialog-content>
      <h4 class="font-weight-bold title-text">
        {{ "EmailChange-modal-title" | translate }}
        <img src="assets/img/Complaint.svg" alt="Complaint" class="withdraw-icon">
      </h4>
      <p class="text-muted-special subtitle-text">{{ "EmailChange-modal-subtitle" | translate }}</p>

      <div class="settings-profile">
        <!-- <div class="stepper-overlay" *ngIf="!selectedAccount">
          <div class="overlay-content">
            {{ "choose-account" | translate }}
          </div>
        </div> -->
        <form #EmailChangeForm="ngForm" (ngSubmit)="submitChangeEmailRequest(EmailChangeForm)">
          <div class="form-row">
                        <!-- <div class="col-md-6 mb-3">
              <label class="required form-field-title">{{ "select-account" | translate }}</label>
            <div class="custom-position">
              <user-selection
                [isBindValue]="true"
                (userChanged)="clientSelected($event)"
              ></user-selection>
            </div>
          </div> -->
            <div class="col-md-6 mb-3">
              <label class="required form-field-title">{{
                "email" | translate
              }}</label>
              <input
                  [(ngModel)]="newEmail"
                name="Contact"
                type="email"
                class="form-control"
                [maxlength]="55"
                placeholder="{{ 'EnterNewEmail' | translate }}"
                [required]="true"
                autocomplete="off"
                autocorrect="off"
                spellcheck="false"
                email="true"
              />
          </div>

          </div>
          <div class="col-12 d-flex justify-content-end" style="justify-content: end">
            <button class="btn btn-primary" type="submit" [disabled]="EmailChangeForm.invalid || isSubmitting ">
              <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm"></span>
              {{ "send" | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>